/*
 * Copyright (c) 2024 by N-Ach (Pvt) Ltd
 *
 * ╔═╗ ╔╗    ╔═══╗  ╔╗
 * ║║╚╗║║    ║╔═╗║  ║║
 * ║╔╗╚╝║    ║║ ║╠══╣╚═╗
 * ║║╚╗║║╔══╗║╚═╝║╔═╣╔╗║
 * ║║ ║║║╚══╝║╔═╗║╚═╣║║║
 * ╚╝ ╚═╝    ╚╝ ╚╩══╩╝╚╝
 *
 * All rights reserved.
 *
 * This software is the confidential and proprietary information
 * of N-Ach (Pvt) Ltd. You shall not disclose such Confidential
 * Information and shall use it only in accordance with the terms
 * of the license agreement you entered into with N-Ach (Pvt) Ltd.
 *
 *
 * @Author Dilhari Jayathunga
 * @Date 24/9/2024
 */

import { Button, Container, Dialog, DialogContent, Typography } from '@mui/material'
import React from 'react'

const Success = ({ open, onClose }) => {
    return (
        <Dialog
            fullWidth={true}
            open={open}
            onClose={() => onClose()}
            maxWidth={"xs"}
            aria-labelledby="success-dialog-title"
            aria-describedby="success-dialog-description"
        >
            <DialogContent>
                <Container maxWidth="md">

                    <Typography my={3} variant="h5" component="div" color="text.primary" textAlign="center" fontWeight="bold">
                        Thank You!
                    </Typography>

                    <Typography my={3} component="div" color="text.primary" textAlign="center" fontWeight="400">
                        Your message successfully recieved.
                    </Typography>

                    <div style={{ display: 'flex', justifyContent: 'center', marginTop: "1rem" }}>
                        <Button onClick={() => onClose()} style={{margin: '0.5rem', width: "10rem"}} fullWidth variant="contained" aria-label="Cancel">Okay</Button>
                    </div>

                </Container>
            </DialogContent>
        </Dialog>
    )
}

export default Success